var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Button',{attrs:{"_key":"btncCostCenterCreate","title":"Centro de Custo","classIcon":"fas fa-plus-circle","type":"primary","size":"small","eventName":"costCenterCreate"}}),_c('CostCenterList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }